import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, Inject, Input } from "@angular/core";
import { RegistryContextInfo } from "@app/models/constants/registry-constants";
import { CommonActions } from "@app/store/common/common.actions";
import { CommonState } from "@app/store/common/common.state";
import { ModalController } from "@ionic/angular";
import { DoctorPanelActions } from "@modules/doctor-panel/store/doctor-panel.actions";
import { DoctorPanelState } from "@modules/doctor-panel/store/doctor-panel.state";
import { hasActionsExecuting } from "@ngxs-labs/actions-executing";
import { Select, Store } from "@ngxs/store";
import { Icd9 } from "@trec/api";
import { C3SnackbarStatusService } from "@trec/components/snackbar-status";
import { firstValueFrom, Observable } from "rxjs";

@Component({
  selector: "app-edit-operation-dialog",
  standalone: false,
  templateUrl: "./edit-operation-dialog.component.html",
  styleUrl: "./edit-operation-dialog.component.scss",
})
export class EditOperationDialogComponent {
  @Input()
  icd9Code: any;
  @Input()
  context: any;
  @Input()
  icd9Description: any;
  @Input()
  selectedOperationDate: string | null = null;

  creationDialog: boolean = true;
  deleteDialog: boolean = false;

  @Select(hasActionsExecuting([DoctorPanelActions.FetchIcd9OperationsList]))
  loading$: Observable<boolean>;

  codiceIcd9;
  listaCodiciIcd9: Icd9[];
  selectedIcd9: Icd9 | null;
  // 👇 nuovi
  patientContexts: string[] = [];
  patientContextsInfo: { [key: string]: RegistryContextInfo } = {};
  selectedContext: string | null = null;

  @Input()
  deleteAction: boolean = false;

  //description: boolean = false;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    private store: Store,
    private cd: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private c3Snackbar: C3SnackbarStatusService,
  ) {
    this.patientContexts = this.store.selectSnapshot(CommonState.patientContext) ?? [];

    // Ottieni la lista delle operazioni già salvate
    const icd9PatientList = this.store.selectSnapshot(DoctorPanelState.icd9Patient) ?? [];

    // Trova i contesti già utilizzati per operazioni
    const usedContexts = icd9PatientList
      .filter(
        (item) =>
          item.icd9SurgicalOperationCode && item.icd9SurgicalOperationDescription && item.context,
      )
      .map((item) => item.context);

    // Filtra i contesti disponibili escludendo quelli già utilizzati (solo se non siamo in modalità modifica)
    const availableContexts = this.context
      ? this.patientContexts // Se stiamo modificando, mostra tutti i contesti
      : this.patientContexts.filter((ctx) => !usedContexts.includes(ctx));

    // Comporre oggetto CONTEXTS_INFO usando i contesti disponibili come chiavi
    let contextInfo = JSON.parse(localStorage.getItem("CONTEXTS_INFO") || "{}");
    availableContexts.forEach((contextKey) => {
      if (contextInfo[contextKey]) {
        this.patientContextsInfo[contextKey] = contextInfo[contextKey];
      }
    });

    // se esiste un solo contesto disponibile, lo imposto subito come selezionato
    if (availableContexts.length === 1) {
      this.selectedContext = availableContexts[0];
    }
  }

  async ngOnInit(): Promise<void> {
    console.log("icd9Code", this.icd9Code);
    console.log("context", this.context);

    if (this.icd9Code !== "n/d" && this.icd9Code) {
      this.codiceIcd9 = this.icd9Code;
      this.creationDialog = false;

      if (this.context) {
        this.selectedContext = this.context;
      }

      // aspetta che la lista venga caricata
      const lista = await this.fetchListCodici(true);
      this.listaCodiciIcd9 = lista ?? [];

      console.log("listaCodiciIcd9", this.listaCodiciIcd9);
      // cerca l’oggetto con id === this.icd9Code
      const found = this.listaCodiciIcd9.find((x) => x.id === this.icd9Code);

      if (found) {
        this.selectedIcd9 = found;
      } else {
        this.selectedIcd9 = null;
      }

      console.log(this.selectedIcd9);
      this.cd.markForCheck();
    } else {
      this.selectedIcd9 = null;
    }

    console.log("selectedIcd9", this.selectedIcd9);
  }

  async fetchListCodici(editFirstCall?: boolean): Promise<Icd9[]> {
    await firstValueFrom(
      this.store.dispatch(
        new DoctorPanelActions.FetchIcd9OperationsList(
          this.codiceIcd9,
          editFirstCall ? true : false,
          false,
        ),
      ),
    );

    // a questo punto l’azione è finita e lo stato è aggiornato
    return this.store.selectSnapshot(DoctorPanelState.icd9OperationsList) ?? [];
  }

  async onQuickFilterChange(value: string | Icd9) {
    if (typeof value === "string" && value.length >= 3) {
      const lista = await this.fetchListCodici();
      this.listaCodiciIcd9 = lista ?? [];
    } else if (typeof value !== "string") {
      this.onIcd9Selected(value);
    }
  }

  onIcd9Selected(code: Icd9 | null = null) {
    this.selectedIcd9 = code;
    this.codiceIcd9 = "";
    this.cd.markForCheck();
  }

  onSubmit() {
    let patientId = this.store.selectSnapshot(CommonState.patientId)!;
    let icd9 = this.selectedIcd9 ? this.selectedIcd9!.id : "";
    const currContext = this.store.selectSnapshot(CommonState.currentContext) ?? "";
    let operationDate = this.selectedOperationDate ? this.selectedOperationDate : "";

    this.store
      .dispatch(
        new DoctorPanelActions.UpdateIcd9Operation(
          this.selectedContext ?? "",
          icd9,
          patientId,
          operationDate,
        ),
      )
      .subscribe(
        () => {
          this.c3Snackbar.showSuccess({ message: `Data operazione modificata correttamente` });
          this.modalCtrl.dismiss(this.selectedIcd9);
          const structureId = this.store.selectSnapshot(CommonState.currentStructureId);

          this.store
            .dispatch(
              new CommonActions.FetchPatientInfo({
                patientId: patientId,
                structureId,
                currContext,
              }),
            )
            .subscribe(() => {
              this.store.dispatch(new DoctorPanelActions.FetchOperationsList());
            });
        },
        (err) => {
          this.c3Snackbar.showError(err);
        },
      );
  }

  /*toggle(checked: boolean) {
    this.description = checked;
    this.cd.markForCheck();
  }*/

  onClose() {
    this.modalCtrl.dismiss();
  }

  get canSubmit(): boolean {
    return !!(
      this.selectedIcd9 &&
      this.selectedOperationDate &&
      this.selectedContext // 👈 richiediamo anche il contesto
    );
  }

  deleteOperation() {
    const patientId = this.store.selectSnapshot(CommonState.patientId)!;
    this.store
      .dispatch(new DoctorPanelActions.DeleteIcd9Operation(this.selectedContext ?? "", patientId))
      .subscribe(
        () => {
          this.c3Snackbar.showSuccess({ message: `Operazione eliminata correttamente` });
          this.modalCtrl.dismiss(true);
          const structureId = this.store.selectSnapshot(CommonState.currentStructureId);
          const currContext = this.store.selectSnapshot(CommonState.currentContext) ?? "";

          this.store
            .dispatch(
              new CommonActions.FetchPatientInfo({
                patientId: patientId,
                structureId,
                currContext,
              }),
            )
            .subscribe(() => {
              this.store.dispatch(new DoctorPanelActions.FetchOperationsList());
            });
        },
        (err) => {
          this.c3Snackbar.showError(err);
        },
      );
  }
}
